module.exports = {
  iq: ["section_list_cards.list"],
  cp: [
    "section_list_cards.list",
    "section_list_accounts.list",
    "section_list_acquirer.list",
    "section_list_loans.list",
    "marketplace_product_acquirer.flags",
    "section_products_highlighted_acquirer.body",
    "section_products_highlighted_account.body",
    "section_products_highlighted_loans.body"
  ],
  ccbr: ["section_list_cards.list"],
  azulis: [
    "section_list_cards.list",
    "section_list_accounts.list",
    "section_list_acquirer.list",
    "section_list_loans.list",
    "marketplace_product_acquirer.flags",
    "section_products_highlighted_acquirer.body",
    "section_products_highlighted_account.body",
    "section_products_highlighted_loans.body"
  ],
  mastercard: [
    "section_list_cards.list"
  ]
}
